import { List } from 'lucide-react';

import BaseItem from './Base';
import { TYPE_LIST, TYPE_OBJECT } from './types';

export default class ListItem extends BaseItem {
  accept = [TYPE_LIST, TYPE_OBJECT]
  icon = List
  title = "list"
  multipleChildren = true
  type = TYPE_LIST
}
